import { Product } from "../models/Product";

// Internal product name stored in the database; customers see the display name
export const REPORT_RUNNER_PRODUCT_NAME = "ReportRunner";
export const REPORT_RUNNER_DISPLAY_NAME = "Report Runner";

export const isReportRunnerProduct = (
  product: Product | null | undefined
): boolean => {
  return product?.name === REPORT_RUNNER_PRODUCT_NAME;
};

export const getProductDisplayName = (
  product: Product | null | undefined
): string | undefined => {
  return isReportRunnerProduct(product) ? REPORT_RUNNER_DISPLAY_NAME : product?.name;
};
